/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";
import BaseVariantLayout from "@/layouts/base-variant-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
  baseVariant: BaseVariantLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  "application_account-reset": () => import("@/views/application/account-reset/index.vue"),
  "application_application-version": () => import("@/views/application/application-version/index.vue"),
  "application_develop-detail": () => import("@/views/application/develop-detail/index.vue"),
  application_develop: () => import("@/views/application/develop/index.vue"),
  "application_protocal-manage": () => import("@/views/application/protocal-manage/index.vue"),
  "client_management-add": () => import("@/views/client/management-add/index.vue"),
  "client_management-edit": () => import("@/views/client/management-edit/index.vue"),
  client_management: () => import("@/views/client/management/index.vue"),
  client_platform: () => import("@/views/client/platform/index.vue"),
  "data_all-screen": () => import("@/views/data/all-screen/index.vue"),
  "data_app-chart": () => import("@/views/data/app-chart/index.vue"),
  "data_product-chart": () => import("@/views/data/product-chart/index.vue"),
  home: () => import("@/views/home/index.vue"),
  "product_debug-add": () => import("@/views/product/debug-add/index.vue"),
  "product_debug-detail": () => import("@/views/product/debug-detail/index.vue"),
  product_debug: () => import("@/views/product/debug/index.vue"),
  "product_develop-add": () => import("@/views/product/develop-add/index.vue"),
  "product_develop-detail": () => import("@/views/product/develop-detail/index.vue"),
  "product_develop-lang": () => import("@/views/product/develop-lang/index.vue"),
  product_develop: () => import("@/views/product/develop/index.vue"),
  "product_device-detail": () => import("@/views/product/device-detail/index.vue"),
  product_device: () => import("@/views/product/device/index.vue"),
  product_diagnosis: () => import("@/views/product/diagnosis/index.vue"),
  "product_firmware-add": () => import("@/views/product/firmware-add/index.vue"),
  "product_firmware-list": () => import("@/views/product/firmware-list/index.vue"),
  "product_firmware-task-detail": () => import("@/views/product/firmware-task-detail/index.vue"),
  product_firmware: () => import("@/views/product/firmware/index.vue"),
  product_log: () => import("@/views/product/log/index.vue"),
  "system_account-add": () => import("@/views/system/account-add/index.vue"),
  "system_account-permission": () => import("@/views/system/account-permission/index.vue"),
  system_account: () => import("@/views/system/account/index.vue"),
  "system_api-key-audit": () => import("@/views/system/api-key-audit/index.vue"),
  "system_api-key": () => import("@/views/system/api-key/index.vue"),
  "system_application-detail": () => import("@/views/system/application-detail/index.vue"),
  "system_application-template": () => import("@/views/system/application-template/index.vue"),
  "system_category-add": () => import("@/views/system/category-add/index.vue"),
  "system_category-detail": () => import("@/views/system/category-detail/index.vue"),
  system_category: () => import("@/views/system/category/index.vue"),
  "system_firmwaretype-lang": () => import("@/views/system/firmwareType-lang/index.vue"),
  system_firmwaretype: () => import("@/views/system/firmwareType/index.vue"),
  "system_menu-lang": () => import("@/views/system/menu-lang/index.vue"),
  system_menu: () => import("@/views/system/menu/index.vue"),
  system_role: () => import("@/views/system/role/index.vue"),
  user_center: () => import("@/views/user/center/index.vue"),
  user_company: () => import("@/views/user/company/index.vue"),
  "user_reset-email": () => import("@/views/user/reset-email/index.vue"),
  "user_reset-password": () => import("@/views/user/reset-password/index.vue"),
};
